@let overview = feedback | async;
<app-feedback-graph [feedback]="overview?.byDate" />
<app-feedback-responses [feedback]="overview?.byFeature" />
